import React, { useContext, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import "./FiltrosKinesio.css";
import CheckBoxGroup from "../../Genericos/CheckBoxGroup/CheckBoxGroup";

const FiltrosKinesio = ({
  titulo,
  dissmiss,
  onChangeDatePicker,
  fecha,
  onHandleBuscarTurnosKin,
}) => {
  const { turnosDisponiblesState } = useContext(PortalContext);
  const [arrayDias, setArrayDias] = useState(
    turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.diasKin
  );
  const [arrayRango, setArrayRango] = useState(
    turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.rangoKinesio
  );

  const fechaLimte = new Date();
  const days = 90;
  fechaLimte.setDate(fechaLimte.getDate() + days);

  const handleChangeRango = (e) => {
    setArrayRango(e);
  };

  const handleChangeDia = (e) => {
    setArrayDias(e);
  };
  // dia de hoy
  const hoyDia = new Date();
  const noventaDiasDespues = new Date();
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);

  return (
    <React.Fragment>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      <div className="ptur-filtrosKinesio-container">
        <div className="ptur-filtrosKinesio-dateBox">
          <span className="ptur-filtrosKinesio-checkTitle rb16mh">Fecha</span>
          <DatePicker
            fechaInicial={`${hoyDia.getFullYear()} ${
              hoyDia.getMonth() + 1
            } ${hoyDia.getDate()}`}
            fechaFinal={`${noventaDiasDespues.getFullYear()} ${
              noventaDiasDespues.getMonth() + 1
            } ${noventaDiasDespues.getDate()}`}
            fechaMin={fecha}
            fechaMax={fechaLimte}
            onChange={onChangeDatePicker}
            customCss="ptur-datepicker-kinesio"
          />
        </div>
        <div className="ptur-filtrosKinesio-filtrosBox">
          <div className={`ptur-filtrosKinesio-checkboxes`}>
            <span className="ptur-filtrosKinesio-checkSubTitle rb16mh">
              Días disponibles
            </span>
            <CheckBoxGroup data={arrayDias} onChange={handleChangeDia} />
          </div>
          <div className={`ptur-filtrosKinesio-checkboxes`}>
            <span className="ptur-filtrosKinesio-checkSubTitle rb16mh">
              Rangos horarios
            </span>
            <CheckBoxGroup data={arrayRango} onChange={handleChangeRango} />
          </div>
        </div>
        <div className="ptur-filtrosKinesio-btn-box">
          <button
            className="ptur-filtrosKinesio-btnVolver c-latex30 rb16m"
            onClick={dissmiss}
          >
            Volver
          </button>
          <button
            className="ptur-filtrosKinesio-btnBuscar c-white rb16m"
            onClick={() => onHandleBuscarTurnosKin(arrayDias, arrayRango)}
          >
            Buscar turnos
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FiltrosKinesio;
